import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "setting-data" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "flex-fill" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, null, -1)
const _hoisted_5 = {
  class: "form-horizontal",
  id: "frm_change_cred",
  name: "frm_change_cred",
  role: "form"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 form-group" }
const _hoisted_8 = {
  for: "LoginEmail",
  class: "col-form-label upper"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("input", {
  type: "email",
  name: "LoginEmail",
  id: "LoginEmail",
  class: "form-control"
}, null, -1)
const _hoisted_10 = { class: "col-md-6 form-group" }
const _hoisted_11 = {
  for: "LoginEmail",
  class: "col-form-label upper"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("input", {
  type: "password",
  name: "OldPassword",
  id: "OldPassword",
  class: "form-control"
}, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6 form-group" }
const _hoisted_15 = {
  for: "LoginEmail",
  class: "col-form-label upper"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("input", {
  type: "password",
  name: "NewPassword",
  id: "NewPassword",
  class: "form-control"
}, null, -1)
const _hoisted_17 = { class: "col-md-6 form-group" }
const _hoisted_18 = {
  for: "LoginEmail",
  class: "col-form-label upper"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("input", {
  type: "password",
  name: "ConfPassword",
  id: "ConfPassword",
  class: "form-control"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", null, [
      _createElementVNode("h2", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'lock'] }),
        _createTextVNode(" " + _toDisplayString(_ctx.language.changeCredentials), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.language.change_cred_def), 1)
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.language.changeCredentials), 1),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn-xs",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitPasswordChange()))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'wrench'] }),
            _createTextVNode(" " + _toDisplayString(_ctx.language.save), 1)
          ])
        ])
      ]),
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.language.login), 1),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.language.old_pw), 1),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.language.new_pw), 1),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.language.conf_pw), 1),
            _hoisted_19
          ])
        ])
      ])
    ])
  ]))
}